// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"b8eb3ae8","637":"2f574045"}[chunkId] + ".chunk.css";
};